export const toAbsoluteUrl = (pathname: string) => {
  const baseUrl = process.env.PUBLIC_URL || '/';
  const normalizedPath = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  return baseUrl + normalizedPath;
};
